import ChangePass from '@/pages/profile/ChangePass'
import Profile from '@/pages/profile/Profile'

export default [
    {
        path: '/app/profile',
        component: Profile,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/app/profile/change-password',
        component: ChangePass,
        meta: {
            requiresAuth: true
        }
    }
]
